// PATH: src/components/ProgrammeTag.tsx — marque d'un élément importé du
// programme marocain (catalogue tc_embed) : verrouillé, ni modifiable ni
// supprimable. Même libellé partout où un tel élément apparaît.
import React from "react";
import { Tag, Tooltip } from "antd";
import { LockOutlined } from "@ant-design/icons";

const ProgrammeTag: React.FC = () => (
  <Tooltip title="Importé du programme marocain : ni modifiable ni supprimable">
    <Tag icon={<LockOutlined />} color="gold" style={{ marginInlineEnd: 0 }}>
      Programme marocain
    </Tag>
  </Tooltip>
);

export default ProgrammeTag;
